module.exports = __webpack_public_path__ + "img/jd_peiquan.3b714d7f.png";